import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./Snapshot.form";
import { MemoTable } from "./Snapshot.table";
import { SnapshotResumen } from "./SnapshotResumen.cards";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { cambiarVendedorFormConfig } from "./SnapshotVendedor.form";
import { cambiarPeriodoFormConfig } from "./SnapshotPeriodo.form";
import { gestionFormConfig } from "./SnapshotGestion.form";
import { SnapshotDispatcher } from "../../../containers/comisionesAnualidad/snapshot/Snapshot.dispatcher";
import { SnapshotStore } from "../../../containers/comisionesAnualidad/snapshot/Snapshot.store";
import AnualidadSnapshot from "../../../../types/AnualidadSnapshot";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetSnapshot } from "../../../reducers/comisionAnualidad";
import {
  downloadSnapshotByAsesor,
  downloadSnapshotByFolioFactura,
  downloadSnapshotByPeriodo
} from "../../../actions/comisionAnualidad";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import s from "./styles.scss";

interface Props extends SnapshotDispatcher, SnapshotStore, RouterProps {}

interface State {
  downloading: boolean;
  tipoBusqueda: string;
  filters: Inputs & {
    periodo: string;
    page: number;
    size: number;
  };

  row: AnualidadSnapshot;
  actualizarPopupOpen: boolean;
  cambiarVendedorPopupOpen: boolean;
  cambiarPeriodoPopupOpen: boolean;
  descartarPopupOpen: boolean;
}

@Styled(s)
export default class SnapshotComponent extends Component<Props, State> {
  state = {
    downloading: false,
    tipoBusqueda: "",
    filters: {
      periodo: null,
      page: 0,
      size: 100
    } as any,
    currentResumen: null,

    row: null as AnualidadSnapshot,
    actualizarPopupOpen: false,
    cambiarVendedorPopupOpen: false,
    cambiarPeriodoPopupOpen: false,
    descartarPopupOpen: false
  };

  componentDidMount(): void {
    this.props.clearSnapshot();
    this.props.clearResumen();
  }

  clear = () => {
    this.setState({
      tipoBusqueda: "",
      filters: {
        page: 0,
        size: 100
      } as any
    });
  };

  getResumenByPeriodo = async (anio, mes, idClub?) => {
    const periodo = `${anio || new Date().getFullYear()}-${mes}-01`;
    const preview = !!idClub
      ? await this.props.getResumenByPeriodoAndIdClub(periodo, idClub)
      : await this.props.getResumenByPeriodo(periodo);

    if (!preview.fulfilled) {
      errorNotification(preview.gettingResumenSnapshotError);
    }
  };

  fetchData = async ({ page, pageSize }) => {
    const { tipoBusqueda, filters } = this.state;
    const params = {
      ...filters,
      page,
      size: pageSize
    };

    let preview: Preview<GetSnapshot>;

    if (!tipoBusqueda) {
      preview = await this.props.getSnapshotByPeriodo(
        params.periodo,
        params.idClub,
        params.soloContactCenter,
        params.conCambios,
        params.evaluadorModifico,
        params.page,
        params.size
      );
    } else if (tipoBusqueda === "factura") {
      preview = await this.props.getSnapshotByFolioFactura(
        params.folioFactura,
        params.page,
        params.size
      );
    } else {
      preview = await this.props.getSnapshotByAsesor(
        params.periodo,
        params.idVendedor,
        params.page,
        params.size
      );
    }

    if (!preview.fulfilled) {
      errorNotification(preview.gettingSnapshotError);
    }
  };

  generarSnapshot = async () => {
    infoNotification("Generando Snapshot...");

    const { page, size } = this.state.filters;
    const now = new Date();
    now.setDate(now.getDate() - 2);

    const periodo = new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
    const preview = await this.props.postSnapshotByPeriodo(periodo);

    if (preview.fulfilled) {
      successNotification("El snapshot se generó correctamente");
      this.fetchData({ page, pageSize: size });
    } else {
      errorNotification(preview.postingSnapshotByPeriodoError);
    }
  };

  submit = (data: { [key in Inputs]: any }) => {
    this.setState(
      {
        tipoBusqueda: data.tipoBusqueda,
        filters: {
          ...data,
          periodo: `${data.anio || new Date().getFullYear()}-${data.mes}-01`,
          page: 0,
          size: 100
        } as any
      },
      () => this.fetchData({ page: 0, pageSize: 100 })
    );

    if (!data.tipoBusqueda) {
      this.getResumenByPeriodo(data.anio, data.mes, data.idClub);
    } else if (data.tipoBusqueda === "asesor") {
      this.getResumenByPeriodo(data.anio, data.mes);
    } else {
      this.props.clearResumen();
    }
  };

  handleExport = async () => {
    const { tipoBusqueda, filters } = this.state;
    this.setState({ downloading: true });

    if (!tipoBusqueda) {
      downloadSnapshotByPeriodo(
        filters.periodo,
        filters.idClub,
        filters.soloContactCenter,
        filters.conCambios,
        filters.evaluadorModifico,
        () => this.setState({ downloading: false })
      );
    } else if (tipoBusqueda === "factura") {
      downloadSnapshotByFolioFactura(filters.folioFactura, () =>
        this.setState({ downloading: false })
      );
    } else {
      downloadSnapshotByAsesor(filters.periodo, filters.idVendedor, () =>
        this.setState({ downloading: false })
      );
    }
  };

  handleActualizarSnapshot = (row: AnualidadSnapshot) => {
    this.setState({
      actualizarPopupOpen: true,
      row: row
    });
  };

  handleActualizarSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putSnapshotEvaluacion(
      row.idCotizacionItem,
      {
        modo: data.modo,
        observaciones: data.observaciones,
        idClubModificado: data.idClubModificado
          ? parseInt(data.idClubModificado as any)
          : null,
        precioVentaModificado: data.precioVentaModificado
          ? parseFloat(data.precioVentaModificado as any)
          : null
      }
    );

    if (preview.fulfilled) {
      successNotification("La anualidad se configuró correctamente");

      this.setState({
        actualizarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });

      // Necesario para recalcular por cambios de club
      if (!this.state.tipoBusqueda) {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes,
          this.state.filters.idClub
        );
      } else if (this.state.tipoBusqueda === "asesor") {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes
        );
      } else {
        this.props.clearResumen();
      }
    } else {
      errorNotification(preview.puttingSnapshotEvaluacionError);
    }
  };

  handleCambiarVendedor = (row: AnualidadSnapshot) => {
    this.setState({
      row,
      cambiarVendedorPopupOpen: true
    });
  };

  handleCambiarVendedorSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putCambiarVendedor(row.idCotizacionItem, {
      idVendedor: parseInt(data.idVendedor as any),
      razonCambioVendedor: data.razonCambioVendedor
    });

    if (preview.fulfilled) {
      successNotification("Vendedor actualizado correctamente");

      this.setState({
        cambiarVendedorPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingCambiarVendedorError);
    }
  };

  handleCambiarPeriodo = (row: AnualidadSnapshot) => {
    this.setState({
      row,
      cambiarPeriodoPopupOpen: true
    });
  };

  handleCambiarPeriodoSubmit = async data => {
    const { row } = this.state;
    const periodo = `${data.anio}-${data.mes}-01`;
    const preview = await this.props.putCambiarPeriodo(row.idCotizacionItem, {
      periodo,
      razonCambioPeriodo: data.razonCambioPeriodo
    });

    if (preview.fulfilled) {
      successNotification("Periodo actualizado correctamente");

      this.setState({
        cambiarPeriodoPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });

      // Recalcular resumen porque puede afectar el periodo del listado actual
      if (!this.state.tipoBusqueda) {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes,
          this.state.filters.idClub
        );
      } else if (this.state.tipoBusqueda === "asesor") {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes
        );
      } else {
        this.props.clearResumen();
      }
    } else {
      errorNotification(preview.puttingCambiarPeriodoError);
    }
  };

  handleDescartarCambios = (row: AnualidadSnapshot) => {
    this.setState({
      row,
      descartarPopupOpen: true
    });
  };

  handleDescartarConfirm = async () => {
    const { row } = this.state;
    const result = await this.props.deleteSnapshotEvaluacion(
      row.idCotizacionItem
    );

    if (result.fulfilled) {
      successNotification("Los cambios se descartaron correctamente");

      this.setState({
        descartarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });

      // Necesario para recalcular por cambios de club
      if (!this.state.tipoBusqueda) {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes,
          this.state.filters.idClub
        );
      } else if (this.state.tipoBusqueda === "asesor") {
        this.getResumenByPeriodo(
          this.state.filters.anio,
          this.state.filters.mes
        );
      } else {
        this.props.clearResumen();
      }
    } else {
      errorNotification(result.deletingSnapshotEvaluacionError);
    }
  };

  render() {
    const {
      row,
      actualizarPopupOpen,
      cambiarVendedorPopupOpen,
      cambiarPeriodoPopupOpen,
      descartarPopupOpen
    } = this.state;

    const rowPeriodoMes = row && row.periodo ? row.periodo.substring(5, 7) : "";
    const rowPeriodoAnio =
      row && row.periodo ? Number(row.periodo.substring(0, 4)) : "";

    return (
      <Container>
        <SnapshotResumen
          resumen={this.props.resumenSnapshot}
          loading={
            this.props.gettingSnapshot ||
            this.props.gettingResumenSnapshot ||
            this.props.postingSnapshotByPeriodo ||
            this.state.downloading
          }
        />

        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={
            this.props.gettingSnapshot ||
            this.props.gettingResumenSnapshot ||
            this.props.postingSnapshotByPeriodo ||
            this.state.downloading
          }
        >
          <IButtonBuilder
            name="generarSnapshot"
            disabled={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onClick={this.generarSnapshot}
          />
        </FormBuilder>

        {this.props.snapshot && (
          <MemoTable
            page={this.props.snapshot}
            loading={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onFetchData={this.fetchData}
            onExport={this.handleExport}
            onActualizarSnapshot={this.handleActualizarSnapshot}
            onCambiarVendedor={this.handleCambiarVendedor}
            onCambiarPeriodo={this.handleCambiarPeriodo}
            onDescartarCambios={this.handleDescartarCambios}
          />
        )}

        <FormBuilderModal
          isOpen={actualizarPopupOpen}
          title={`Actualizar Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleActualizarSubmit}
          cancel={() => this.setState({ actualizarPopupOpen: false })}
          formConfig={gestionFormConfig}
          values={{
            modo: (row && row.modo) || "",
            observaciones: (row && row.observaciones) || "",
            idClubModificado: (row && row.idClubModificado) || "",
            precioVentaModificado: (row && row.precioVentaModificado) || ""
          }}
        />

        <FormBuilderModal
          isOpen={cambiarVendedorPopupOpen}
          title={`Vendedor de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarVendedorSubmit}
          cancel={() => this.setState({ cambiarVendedorPopupOpen: false })}
          formConfig={cambiarVendedorFormConfig}
          values={{
            idVendedor: (row && row.idVendedor) || "",
            razonCambioVendedor: (row && row.razonCambioVendedor) || ""
          }}
        />

        <FormBuilderModal
          isOpen={cambiarPeriodoPopupOpen}
          title={`Periodo de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarPeriodoSubmit}
          cancel={() => this.setState({ cambiarPeriodoPopupOpen: false })}
          formConfig={cambiarPeriodoFormConfig}
          values={{
            mes: rowPeriodoMes,
            anio: rowPeriodoAnio,
            razonCambioPeriodo: ""
          }}
        />

        <ConfirmModal
          isOpen={descartarPopupOpen}
          title={`Reestablecer Cotización ${!!row && row.idCotizacionItem}`}
          message={"Los cambios detectados y sus comentarios serán ignorados."}
          ok={this.handleDescartarConfirm}
          cancel={() => this.setState({ descartarPopupOpen: false })}
          size={"md"}
          waiting={this.props.deletingSnapshotEvaluacion}
        />
      </Container>
    );
  }
}
